// @ts-strict

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { leadsStatusesTranslated } from '@app/core/helpers/constants';
import { PostbackUrlComponent } from './postback-url/postback-url.component';
import { PostbackApiConfigService } from '@app/core/services/postback-api-config/postback-api-config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { leadsStatuses } from '@app/core/helpers/constants';
import { TranslateService } from '@ngx-translate/core';
import { ISingleCampaign, SpecialCampaignData } from '@app/core/models/core-models';
import { IPostbackEditModalConfigData } from '@app/core/types/postback-api-config/postback-api-config.service.types';
import { SelectContainerChosenValue } from '@app/shared/components/select-container/select-container.component';
import { UrlAddressConfigService } from '@app/core/services/url-address-config/url-address-config.service';
import { decodeHtml } from '@app/core/helpers/decode-html';
import { toNumber } from 'lodash';
import { urlParameters } from '@app/core/helpers/constants';
import { GlobalNotificationsService } from '@app/core/services/global-notifications/global-notifications.service';
import { NotificationTypes } from '@app/core/services/global-notifications/global-notifications.model';

@Component({
  selector: 'app-postback-url-modal',
  templateUrl: './postback-url-modal.component.html',
  styleUrls: ['./postback-url-modal.component.scss']
})
export class PostbackUrlModalComponent implements OnInit {
  @Input() currentCampaign?: ISingleCampaign | SpecialCampaignData;
  @Input() configurationData?: IPostbackEditModalConfigData;
  @Input() isGlobalConfiguration: boolean = false;
  @Input() programId: number | undefined = undefined;

  @ViewChild(PostbackUrlComponent) urlAddressComponent?: PostbackUrlComponent;

  public readonly urlParameters = urlParameters;

  public submitted = false;
  public isSuccessfullySubmitted = false;
  public selectedConfigurationName: string = '';
  public usedParameters: string[] = [];
  public parameterAdded = false;
  public removedParam = '';
  public idOfRemovedParam = 0;
  public buttonText = 'create_postback_url';
  public address = '';
  public idOfDefaultValue = 4;
  public idOfDefaultConfig = 0;
  public selectData: {
    title: string;
    data: {
      id: number;
      name: string;
    }[];
  } = {
    title: 'postpack_status_title',
    data: []
  };

  public configurationsSelectData: {
    title: string;
    data: {
      id: number | null;
      name: string;
    }[];
  } = {
    title: 'configurations',
    data: [{ id: null, name: this.translate.instant('view_translations.no_data') }]
  };
  private postbackStatuses = Object.keys(leadsStatuses);
  private urlAddress: string = '';
  private leadStatus = -1;

  private configurationId?: number;

  public isUrlValid = false;

  constructor(
    private globalNotificationsService: GlobalNotificationsService,
    private postbackAPIService: PostbackApiConfigService,
    public activeModal: NgbActiveModal,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.postbackStatuses.map(status => {
      this.selectData.data.push({
        name: this.getDisplayStatusName(status as keyof typeof leadsStatuses),
        id: parseInt(status, 10)
      });
    });
    if (this.configurationData) {
      this.buttonText = 'edit_postback';
      this.idOfDefaultValue = this.selectData.data.findIndex(status => status.id === this.configurationData?.postback_status?.value);
      this.leadStatus = typeof this.configurationData?.postback_status?.value === 'number' ? this.configurationData?.postback_status?.value : -1;

      if (typeof this.configurationData.postback_url?.value === 'string') this.setInitialUsedParameters(this.configurationData.postback_url?.value ?? '');

      if (this.configurationData.configuration_id) {
        this.configurationId = this.configurationData.configuration_id.value as number | undefined;
        Object.entries(this.configurationData.configuration_id?.values as Record<any, any>).map(([key, value]) =>
          this.configurationsSelectData.data.push({ id: toNumber(key), name: value.toString() })
        );
      }
    }

    if (!this.configurationData) {
      const currentCampaignId = this.currentCampaign?.id || 0;
      const programId = this.programId || currentCampaignId;
      this.postbackAPIService.getFieldsToCreate(programId).subscribe(({ data }) => {
        this.configurationData = { ...(data?.postback_fields || {}), postback_id: 0 };
        if (this.configurationData.configuration_id?.values) {
          Object.entries(this.configurationData.configuration_id?.values as Record<any, any>).map(([key, value]) =>
            this.configurationsSelectData.data.push({ id: toNumber(key), name: value.toString() })
          );
        }
      });
    }
    if (this.configurationData?.configuration_id?.value) {
      this.idOfDefaultConfig = this.configurationsSelectData.data.findIndex(item => item.id === this.configurationData?.configuration_id?.value);
    }
  }

  public actionButton(): void {
    if (this.isSuccessfullySubmitted) {
      this.activeModal.close();
    } else {
      this.verify();
    }
  }

  public closeModal(): void {
    this.activeModal.close();
  }

  public getSelectedValue(value: SelectContainerChosenValue): void {
    this.leadStatus = value.choosenValue.id;
    this.idOfDefaultValue = this.selectData.data.findIndex(status => status.id === this.leadStatus);
  }

  public getSelectedConfigurationValue(value: SelectContainerChosenValue): void {
    this.configurationId = value.choosenValue.id;
    this.idOfDefaultConfig = this.configurationsSelectData.data.findIndex(item => item.id === value.choosenValue.id);
  }

  private getDisplayStatusName(status: string | number | undefined): string {
    return leadsStatusesTranslated[status as keyof typeof leadsStatusesTranslated] || '';
  }

  public getParameters(parameter: string): void {
    if (this.usedParameters.includes(parameter)) {
      this.removedParam = parameter;
      this.idOfRemovedParam = this.usedParameters.indexOf(parameter);
      this.parameterAdded = false;
      this.usedParameters = this.usedParameters.filter(el => el !== parameter);
    } else {
      this.removedParam = '';
      this.parameterAdded = true;
      this.usedParameters.push(parameter);
      this.usedParameters = this.usedParameters.filter(el => el.toString() !== '0');
    }
  }

  public handleUrlValidity = (isValid: boolean) => {
    this.isUrlValid = isValid;
  };

  public getDecodedHtml(data: string | undefined): string {
    return decodeHtml(data);
  }

  private verify(): void {
    this.submitted = true;
    this.urlAddress = this.urlAddressComponent?.urlAddressForm?.value?.urlAddress || '';
    this.urlAddressComponent?.urlAddressForm?.controls?.urlAddress?.markAsTouched();
    this.address = this.urlAddress;
    if (this.urlAddressComponent?.form.urlAddress.invalid) {
      this.showNotification('bad_url_address_format', NotificationTypes[1]);
      return;
    }

    if (this.configurationData?.postback_id) {
      this.editData();
    } else {
      this.addData();
    }
  }

  private addData(): void {
    const programId = this.currentCampaign?.id ? this.currentCampaign?.id : this.programId;
    this.postbackAPIService.addPostbackAPIConfiguration(this.leadStatus, this.urlAddress, programId, this.configurationId).subscribe(
      res => {
        this.showNotification('postback_added', NotificationTypes[0]);
        if (res.data?.postback) {
          this.postbackAPIService.setCreatedPostbackData(res.data.postback);
        }
        this.isSuccessfullySubmitted = true;
        this.buttonText = 'back_to_configuration_list';
      },
      () => {
        this.showNotification('error_occured', NotificationTypes[1]);
      }
    );
  }

  private editData(): void {
    this.postbackAPIService.editPostbackUrl(this.configurationData?.postback_id || 0, this.urlAddress, this.leadStatus, this.configurationId).subscribe(
      res => {
        this.showNotification('postback_edited', NotificationTypes[0]);
        if (res.data?.postback) {
          this.postbackAPIService.setCreatedPostbackData(res.data.postback);
        }
        this.isSuccessfullySubmitted = true;
        this.buttonText = 'back_to_configuration_list';
      },
      () => {
        this.showNotification('error_occured', NotificationTypes[1]);
      }
    );
  }

  private showNotification(message: string, type: (typeof NotificationTypes)[number], translate: boolean = true): void {
    this.globalNotificationsService.show({
      message: translate && !message.includes('view_translations.') ? `view_translations.${message}` : message,
      type,
      translate,
      isPersistent: false,
      id: ''
    });
  }

  private setInitialUsedParameters = (url: string) => {
    const initialParams: string[] = [];
    this.urlParameters.forEach(param => {
      if (url.includes(`[${param}]`)) initialParams.push(param);
    });
    this.usedParameters = initialParams;
  };
}
